export const getStockFromStockPageData = state =>
  state.preloadedStockPageData.stock;
